import appAxios from "services/axios";
import { SuperAdminService } from "services/superAdminService";

class OffersSAService extends SuperAdminService<any> {
  constructor() {
    super("offers");
  }

  publish = async (id: number) => {
    return appAxios.post(`/superadmin/${this.basePath}/${id}/publish`);
  }
  hide = async (id: number) => {
    return appAxios.post(`/superadmin/${this.basePath}/${id}/hide`);
  }
}

export default new OffersSAService();
